import { withBemMod } from '@bem-react/core';

import { cnIcon } from '@yandex-lego/components/Icon';
import './icon_type_plus.css';

export interface IWithTypePlusProps {
    type?: 'plus';
}

export const withTypePlus = withBemMod<IWithTypePlusProps>(
    cnIcon(),
    { type: 'plus' }
);
